/**
 * Converts data-svg-src="" values into actual SVG's in the DOM
 *
 * @param enableDebug
 */
export default (enableDebug = false) => {
	var svgContainers = document.querySelectorAll('.svg-container');

	svgContainers.forEach(function(container) {
		var svgSrc = container.getAttribute('data-svg-src');

		// Fetch the SVG content
		fetch(svgSrc)
			.then(function(response) {
				return response.text();
			})
			.then(function(data) {
				let isSvg = data.substring(0, 4);

				if ( isSvg === '<svg' ) {
					container.innerHTML = data;
				} else {
					console.log('error fetching ', svgSrc);
				}
			})
			.catch(function(error) {
				console.error('Error fetching the SVG:', error);
			});
	});
};
